import { mapState } from "vuex";

import product from "./product";
import sales from "./sales";
import tools from "./tools";

export default {
  mixins: [product, tools, sales],
  computed: {
    ...mapState("events", ["lot"]),
    ROUTE_MAP() {
      return {
        "user-personal-data": {
          title: "Dados pessoais"
        },
        "user-financial-data": {
          title: "Dados financeiros"
        },
        "new-bank-account": {
          title: "Nova conta bancária"
        },
        // PRODUTOS
        ...this.productRoutes,

        // PRÓXIMOS LANÇAMENTOS
        releases: {
          name: "releases",
          title: "Próximos lançamentos"
        },
        "register-releases": {
          name: "register-releases",
          title: "Novo lançamento",
          params: { id: this.$route.params.id }
        },

        // SALDO
        balance: {
          title: "Saldo"
        },

        // FERRAMENTAS
        ...this.toolsRoutes,

        // VENDAS
        ...this.salesRoutes
      };
    },
    breadcrumbs() {
      if (this.$route.name === "home")
        return [{ name: "home", title: "Início" }];

      if (!this.$route.meta.breadcrumbs) return [];

      return [
        { name: "home", title: "Início" },
        ...this.$route.meta.breadcrumbs.map(name => ({
          name,
          ...this.ROUTE_MAP[name]
        }))
      ];
    }
  }
};
